/* eslint-disable no-shadow */
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import EventProfileMatchCard from '../EventProfileMatchCard';
import { EventProfileMatchCardMenuOptions } from '../../../../../utils/constants';
import { renderRoundLabel, getRoundSpacerClassName } from '../../../../../utils/events';
import { getValueByTypeId } from '../../../../../utils/types';

const { EDIT_SCORE, DELETE_SCORE } = EventProfileMatchCardMenuOptions;

const RoundV2 = (props) => {
    const {
        currentDraw,
        round,
        eventSchedule,
        columnNumber,
        displayOnMobile,
        handlePostScore,
        handleClearScore,
        showContactFooter = false,
        showPostScoreForParticipant = false,
        isUserParticipatingInMatch,
    } = props;

    const {
        eliminationTypeId,
        categoryTypeId,
    } = currentDraw.data;

    const scrollRef = useRef(null);
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const coreUI = useSelector(({ coreUI }) => coreUI);
    const event = useSelector(({ eventProfile }) => eventProfile.event);

    const { types: { tms: { division: { tournament: { drawEliminationTypes } } } } } = coreUI;

    const { maxPostScoreDateUtc } = eventSchedule;
    const postScoreEnabled = !!maxPostScoreDateUtc && moment.utc().isBefore(moment(maxPostScoreDateUtc));
    const activeRound = round - columnNumber + 1;

    const handleMatchCardMenuSelect = (menuOption, match, matchIndex) => {
        if (menuOption.id === EDIT_SCORE.id) {
            handlePostScore(round, matchIndex);
        } else if (menuOption.id === DELETE_SCORE.id) {
            handleClearScore(match.id);
        } else {
            // Other menu options not handled here
        }
    };

    return (
        <div
            className={`col-md-4 d-none ${displayOnMobile ? 'd-block' : 'd-md-block'} ${getRoundSpacerClassName(eliminationTypeId, currentDraw.data.rounds, activeRound, columnNumber)}`}
            ref={scrollRef}
        >
            <div
                className="section-header text-small text-medium text-center text-dark mb24"
            >
                {renderRoundLabel(eliminationTypeId ? getValueByTypeId(drawEliminationTypes, eliminationTypeId) : 'default', currentDraw.data.rounds[round], true, categoryTypeId || 'default', currentDraw.data.rounds[round + 1])}
            </div>
            <div className="spacer" />
            {currentDraw.data.rounds[round].matches.map((match, i) => {
                const roundSize = currentDraw.data.rounds[round].matches.length;
                return (
                    <EventProfileMatchCard
                        key={match.id}
                        data-testid={`event-profile.draws.round-${round}.match-${i}`}
                        match={match}
                        draw={currentDraw.data}
                        event={event.data}
                        roundSize={roundSize}
                        postScoreEnabled={postScoreEnabled}
                        onPostScoreClick={() => handlePostScore(round, i)}
                        onMatchCardMenuSelect={(menuOption, m) => handleMatchCardMenuSelect(menuOption, m, i)}
                        showFacilityCourtInfo={true}
                        showUpcomingStatus={false}
                        showMatchDate={true}
                        showDrawName={false}
                        showRoundLevel={true}
                        showContactFooter={showContactFooter}
                        showPostScoreForParticipant={showPostScoreForParticipant && isUserParticipatingInMatch(match)}
                    />
                );
            })}
        </div>
    );
};

RoundV2.propTypes = {
    currentDraw: PropTypes.shape({}).isRequired,
    eventSchedule: PropTypes.shape({}).isRequired,
    round: PropTypes.number,
    columnNumber: PropTypes.number,
    displayOnMobile: PropTypes.bool,
    handlePostScore: PropTypes.func.isRequired,
    handleClearScore: PropTypes.func.isRequired,
    showContactFooter: PropTypes.bool,
    showPostScoreForParticipant: PropTypes.bool,
    isUserParticipatingInMatch: PropTypes.func,
};

RoundV2.defaultProps = {
    round: null,
    columnNumber: null,
    displayOnMobile: false,
    showContactFooter: false,
    showPostScoreForParticipant: false,
    isUserParticipatingInMatch: null,
};

export default RoundV2;
